export default "__VITE_ASSET__a5e58fc7__"